// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"cleanersManagement_wrapper__1-tod","left":"cleanersManagement_left__5pboO","right":"cleanersManagement_right__oaWSo"};